import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/core/service/authentication.service';
import { AuthStorageService } from 'src/app/auth-layout/auth/auth-storage.service';

@Component({
  selector: 'app-save-device-info',
  templateUrl: './save-device-info.component.html',
  styleUrls: ['./save-device-info.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SaveDeviceInfoComponent implements OnInit {
  deviceName = '';
  isdeviceSave: boolean = false;
  numberOfDays: number = 90;
  email: any;
  device: any;
  isTrustDeviceChecked: boolean = false;
  noOfDaysToTrustDevice: number | null = null;
  private isFirstFocus: boolean = true;

  constructor(
    public authService: AuthenticationService,
    public dialogRef: MatDialogRef<SaveDeviceInfoComponent>,
    private authStorage: AuthStorageService
    // @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // this.email = data.email;
    // this.data = data;
    this.authService.getTrustedDeviceExpiryDays().then((res: any) => {
      this.noOfDaysToTrustDevice = res;
    })
  }

  onDeviceNameFocus() {
    if (this.isFirstFocus) {
      this.deviceName = '';
      this.isFirstFocus = false;
    }
  }

  onCheckboxChange(event: any) {
    this.isTrustDeviceChecked = event.checked;
  }

  ngOnInit() {
    this.email = localStorage.getItem('email') || ''
    this.authService.fetchDeviceDetails(this.email).subscribe(
      async (response) => {
        this.deviceName = response.device.device_name;
        this.device = response.device;
        const device_id = await this.authStorage.getAuthToken('device_id') || '';
        if (!device_id) {
          await this.authStorage.saveAuthToken('device_id', response.device.device_id);
        }
        console.log('Device details fetched successfully:', response);
        // Handle the response as needed
      },
      (error) => {
        console.error('Error fetching device details:', error);
        // Handle the error as needed
      }
    );
  }

  skipDeviceSave() {
    this.authService.triggerRememberDevicePopup = false;
    this.dialogRef.close();
    // this.authService.afterMFALogin(this.data)
  }

  saveDevice() {
    if (!this.deviceName.trim()) {
      return;
    }
    this.isdeviceSave = true;
    const updatedDevice = {
      ...this.device,
      device_name: this.deviceName.trim(),
    };
    this.email = localStorage.getItem('email');
    const body = {
      email: this.email,
      device: updatedDevice,
    };
    this.authService.triggerRememberDevicePopup = false;
    this.authService.addUserTrustedDevice(body).subscribe({
      next: (res: any) => {
        this.dialogRef.close();
      },
      error: (err: any) => {
        this.dialogRef.close();
        console.log(err.error);
      },
    });
  }
}
